import {Injectable} from '@angular/core';
import {HttpClient, HttpHandler} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {InitializeRequest} from 'src/app/interfaces/mobicred/InitializeRequest';
import {Observable} from 'rxjs';
import {ValidateRequest} from 'src/app/interfaces/mobicred/ValidateRequest';

@Injectable()
export class MobicredApi extends HttpClient {
  private baseUrl = environment.production ? '/channel-virtual/api/v1' + '/mobicred' : environment.baseUrl + '/mobicred';

  public constructor(handler: HttpHandler) {
    super(handler);
  }

  public initializeMobicredTransaction(sessionToken: string, initializeRequest: InitializeRequest): Observable<any> {
    const url = this.baseUrl + '/initialize' + '?sessionToken=' + sessionToken;
    return super.post(url, initializeRequest);
  }

  public requestMobicredOtp(sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/otp/${sessionToken}`;
    return super.post(url, '');
  }

  public validateMobicredTransaction(sessionToken: string, validateRequest: ValidateRequest): Observable<any> {
    const url = this.baseUrl + `/validate/${sessionToken}`;
    return super.post(url, validateRequest);
  }

  public retrieveMerchantConfig(sessionToken:string): Observable<any>{
    const url = this.baseUrl + `/retrieve-merchant-config?sessionToken=${sessionToken}`;
    return super.get(url);
  }

}
